<template>
    <v-row v-if="!$store.getters.progress" class="pb-offset ma-0">
        <v-col cols="12" class="pt-4">
            <v-card class="flex pa-0 background-2 round-card">
                <v-card-title class="pa-3">
                    <p class="pl-2 pl-xl-3">Modifica Fornitore</p>
                    <v-spacer></v-spacer>
                </v-card-title>
                <v-divider></v-divider>
                <v-container fluid :class="{'px-3': $vuetify.breakpoint.mdAndUp, 'px-0': $vuetify.breakpoint.smAndDown}">
                    <fields-generator
                        class="pt-3"
                        :fieldsset.sync="fieldsset"
                        :model="model"
                        ref="fieldsgenerator"
                    ></fields-generator>
                    <small class="px-4">* Indica i campi obbligatori</small>
                </v-container>
                <v-tooltip top>
                    <template v-slot:activator="{ on: tooltip }">
                        <v-fab-transition>
                            <v-btn
                                v-on="{ ...tooltip }"
                                @click.native="updateModel()"
                                :loading="saved"
                                color="primary"
                                dark
                                absolute
                                bottom
                                right
                                fab>
                                <v-icon>sync</v-icon>
                            </v-btn>
                        </v-fab-transition>
                    </template>
                    <span>Aggiorna</span>
                </v-tooltip>
            </v-card>
        </v-col>

        <v-col cols="12">
            <crud
                ref="crud"
                title='Prodotti Fornitore'
                action-icon='widgets'
                model-def='supplier-product'
                :sub-filters="subFilters"
                :default-input="{company_id: id}"
                action-position='absolute'
                :crud-dialog="true"
                class="mb-4"
                save-and-new
                @update:selected="selected = $event">
            </crud>
        </v-col>

        <confirm-dialog
            :confirmModel="confirmExit"
            :mainTitle="$trans('save_primary_message')"
            :secondTitle="$trans('save_secondary_message')"
            @update:confirmModel="confirmExit = false"
            :exit="{label:'Esci', color:'error'}"
            :atConfirm="updateModel"
            :atExit="exit"
        ></confirm-dialog>
    </v-row>
</template>

<script>

    export default {
        name: 'supplier-edit',
        props: {
            id: Number,
            modelDef: String,
            redirect: Object,
        },

        data() {
            return {
                fieldsset: {},
                model: {},
                saved: false,
                confirmExit: false,
                next: null,
                selected: [],
                subFilters: {'company_id': this.id},
            }
        },

        beforeRouteLeave(to, from, next) {
            if(this.$store.getters.modelEdited) {
                this.confirmExit = true
                this.next = next
            } else {
                next()
            }
        },

        watch: {
            modelForWatcher: {
                handler(newVal, oldVal) {
                    if(!_.isEmpty(oldVal) && !this.$store.getters.progress && (JSON.stringify(newVal) !== JSON.stringify(oldVal))) {
                        this.$store.commit('setModelEdited', true)
                    }
                },
                deep: true,
            },
        },

        created() {
            this.axios.get('suppliers/' + this.id + '/edit').then(response => {
                this.fieldsset = response.data.fields
                this.model = response.data.model

                this.$store.commit('endProgress')
            }, response => {
                // error callback
            })
        },

        beforeDestroy() {
            this.$store.commit('setModelEdited', false)
        },

        computed: {
            modelForWatcher() {
                return _.cloneDeep(this.model)
            },
        },

        methods: {

            exit() {
                this.$store.commit('setModelEdited', false)
                this.next()
            },

            updateModel() {
                this.confirmExit = false
                this.$refs.fieldsgenerator.$validator.validateAll().then(result => {
                    if (!result) {
                        return false
                    }

                    this.saved = true

                    this.axios.put('suppliers/' + this.id, this.model).then(response => {
                        this.saved = false
                        this.$store.commit('setModelEdited', false)
                        if(this.next != null) {
                            this.next()
                        } else {
                            this.$eventBusUtility.chooseRedirect(this.$router, response, this.redirect, 'suppliers')
                        }
                    }, response => {
                        this.saved = false
                        // error callback
                    })
                }).catch(() => {

                })
            },
        },
    }
</script>
